import { NgForm } from '@angular/forms';
import { AfterContentInit, Component, effect, input, output } from '@angular/core';

import { IPaymentInfo } from '../../models/i-payment-models';
import { PAYMENT_PERSON_TYPES } from '../../payment.constants';
import {
  CustomComponent,
  EMAIL_PATTERN,
  IUserCompany,
} from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'payment-contact-info-b',
  templateUrl: './payment-contact-info-b.component.html',
  styleUrls: ['./payment-contact-info-b.component.scss']
})
export class PaymentContactInfoBComponent extends CustomComponent implements AfterContentInit {
  public userInfo = input<IPaymentInfo>();
  public personType = input<string>();
  public countryCode = input<string>();
  public askUserName = input(true);
  public askPhone = input(true);
  public askEmail = input(true);
  public askForReferenceField = input(false);
  public showSmsInfo = input(true);
  public bakeryId = input<number>();
  public useCompanySearcher = input(false);
  public allowToEditCompany = input(true);

  public onValidUpdated = output<boolean>();
  public onInfoUpdated = output<IPaymentInfo>();
  public onCompanySelected = output<IUserCompany>();

  public PAYMENT_PERSON_TYPES = PAYMENT_PERSON_TYPES;
  public EMAIL_PATTERN = EMAIL_PATTERN;

  public form: NgForm;

  public isValid: boolean;
  public info: IPaymentInfo = {};
  public showPhone = false;
  public lookingForAnotherCompany = false;

  constructor() {
    super();

    effect(() => {
      const userInfo = this.userInfo();
      if (userInfo) {
        this.info = { ...userInfo };
      }
    });
  }

  // This hack is need to avoid error: 'ReferenceError: libphonenumber is not defined'
  ngAfterContentInit() {
    setTimeout(() => this.showPhone = this.askPhone());
  }

  public registerForm(form: NgForm) {
    if (!this.form) {
      this.addSubscriber(form.valueChanges.subscribe(() => {
        this.emitStatus();
      }));

      this.form = form;
      this.emitStatus();
    }
  }

  public emitStatus(updatedFields: { [key: string]: any } = null) {
    setTimeout(() => {
      this.isValid = this.form.valid;
      this.onValidUpdated.emit(this.isValid);
      const val = this.form.value;

      // we have to do that as we want to have good names on fields which are prefiled by browsers
      const fieldsMap = {
        full_name: 'userName',
        email: 'userEmail',
        company_name: 'userCompanyName',
        phone: 'userPhone'
      };
      // adding new fields with right keys
      for (const key in val) {
        if (val.hasOwnProperty(key) && fieldsMap[key]) {
          val[fieldsMap[key]] = val[key];
        }
      }
      // removing fields which are not relevant
      for (const key in fieldsMap) {
        delete val[key];
      }

      if (updatedFields) {
        Object.getOwnPropertyNames(updatedFields).forEach(key => val[key] = updatedFields[key]);
      }

      this.onInfoUpdated.emit(val);
    });
  }

  public companySelected(selectedCompany: IUserCompany) {
    this.info.userCompanyName = selectedCompany.legalCompany.name;
    this.lookingForAnotherCompany = false;

    this.emitStatus({
      userCompanyName: selectedCompany.legalCompany.name,
      invoiceCompanyId: selectedCompany.id,
      invoiceCompanyOrgNumber: selectedCompany.legalCompany.orgNumber,
      invoiceCompanyDiscount: selectedCompany.discount,
      invoiceCompanyCountry: selectedCompany.legalCompany.country
    });

    this.onCompanySelected.emit(selectedCompany);
  }

  public changeCompany() {
    this.lookingForAnotherCompany = true;
    this.isValid = false;
    this.onValidUpdated.emit(false);
  }

  public cancelCompanyChange() {
    this.lookingForAnotherCompany = false;
    this.isValid = this.form.valid;
    this.onValidUpdated.emit(this.isValid);
  }
}
